import SkeletonCard from "../../skeletons/SkeletonCard";

const NotificationGroupSkeleton = ({ date, notifications }) => {
  return (
    <>
      <div className="text-base font-semibold text-black mb-2 mt-6">
        <SkeletonCard
          type="text"
          lines={1}
          widths={["150px"]}
          heights={["14px"]}
        />
      </div>
      <div className="bg-gray-100 rounded-xl">
        <div className="bg-white rounded-xl overflow-hidden border border-gray-200">
          {notifications.map((notification, index) => (
            <div
              key={index}
              className={`p-4 flex flex-col md:flex-row md:items-center justify-between space-y-4 md:space-y-0 md:space-x-12 ${
                index !== notifications.length - 1
                  ? "border-b border-gray-200"
                  : ""
              }`}
            >
              {/* Pair + Bot */}
              <div className="flex flex-col min-w-[100px]">
                <span className="text-sm font-medium text-gray-800">
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["60px"]}
                    heights={["10px"]}
                  />
                </span>
                <span className="rounded-full font-semibold w-fit mt-1">
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["40px"]}
                    heights={["10px"]}
                  />
                </span>
              </div>

              {/* Exchange */}
              <div className="flex items-center space-x-2 min-w-[100px]">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/4da79bc120b2adf00fed6f6159aed7bb8a4f35d4a1f8a109f1ad6b71d75cb6f0?placeholderIfAbsent=true&apiKey=59c0fa6b8aa4495494df54f00a70cb5c"
                  alt=""
                  className="w-4 h-4"
                />
                <span className="text-sm text-gray-700 font-medium">
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["40px"]}
                    heights={["10px"]}
                  />
                </span>
              </div>

              {/* Message */}
              <div className="text-sm text-gray-800 flex-1">
                <SkeletonCard
                  type="text"
                  lines={1}
                  widths={["250px"]}
                  heights={["10px"]}
                />
              </div>

              {/* Timestamp */}
              <div className="text-sm text-gray-500 whitespace-nowrap min-w-[100px] text-right">
                <SkeletonCard
                  type="text"
                  lines={1}
                  widths={["150px"]}
                  heights={["10px"]}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default NotificationGroupSkeleton;
